$("#select-dash-categories").on('change', function() {
    dashboard.refresh.areas()
})  

$("#select-dash-areas").on('change', function () {
    dashboard.refresh.all(false)
})  

let dashboard = {
    field: null,
    value: null,
    type: null,
    charts: {},
    style: {
        title:    { color: '#2c3e50', fontSize: '20px', fontWeight: 'bold', fontFamily: 'Segoe UI, Roboto, sans-serif' },
        subtitle: { color: '#7f8c8d', fontSize: '14px', fontWeight: 'bold', fontFamily: 'Segoe UI, Roboto, sans-serif'} 
    },
    menu: ["separator", "downloadPNG", "downloadJPEG", "downloadPDF", "openInCloud"],
    workspace: "/platform",
    logs: { area: {category_id: 'XX', name: "YYYY"}},
    today: new Date(),
    init: {
        all: () => {
            $('select').select2();

            dashboard.init.chart.accum()
            dashboard.init.chart.movel()
            dashboard.init.chart.last()
            dashboard.init.chart.yearly()
            dashboard.init.chart.monthly()
            dashboard.init.table.raking()
            // dashboard.init.chart.biome()
            
            dashboard.refresh.all(false)
        },
        chart: {
            accum: () => {
                dashboard.charts.accum = Highcharts.chart('chart-accum', {
                    title:    { text: 'Acumulado Diário', align: 'center', style: dashboard.style.title },
                    subtitle: { text: 'Bioma - Área ', align: 'center', style: dashboard.style.subtitle },
                    chart: {
                        zoomType: 'x',
                        backgroundColor: null
                    },
                    tooltip: {
                        xDateFormat: '%d/%m',
                        shared: true,
                        split: false,
                        enabled: true
                    },
                    xAxis: {
                        type: 'datetime',
                        crosshair: {
                            snap: true
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Área queimada (ha)',
                            style: {
                                color: "#999999"
                            }
                        }
                    },
                    series: [],
                    responsive: {
                        rules: [{
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom'
                                }
                            }
                        }]
                    },
                    exporting: {
                        filename: `ALARMES-LASA-AQM-ACUMULADO`,
                        buttons: {
                            contextButton: {
                                menuItems: dashboard.menu
                            }
                        },chartOptions: {
                            chart: {
                                backgroundColor: '#ffffff',
                                events: {
                                    load: function () {
                                        this.renderer.image("/img/alarmes-logo.png", (this.chartWidth / 2) - 75, (this.chartHeight / 2) - 75, 150, 150 ).attr({ opacity: 0.15 }).add().toFront();
                                    }
                                }
                            }
                        }
                    }
                })
            },
            movel: () => {
                dashboard.charts.movel = Highcharts.chart('chart-movel', {
                    title: { text: 'Evolução Diária', align: 'center', style: dashboard.style.title },
                    subtitle: { text: 'Bioma - Área ', align: 'center', style: dashboard.style.subtitle },
                    chart: {
                        zooming: {
                            type: 'xy'
                        },
                        backgroundColor: null
                    },
                    xAxis: {
                        categories: [],
                        crosshair: {
                            snap: true
                        }
                    },
                    yAxis: [{
                        title: {
                            text: 'Área queimada (ha)',
                            style: {
                                color: "#999999"
                            }
                        }
                    }],
                    tooltip: {
                        shared: true
                    },
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom'
                    },
                    series: [{
                        name: 'Ano corrente',
                        type: 'column',
                        color: "#E47834",
                        marker: false,
                        data: []
                    }, {
                        name: 'Média móvel',
                        type: 'spline',
                        marker: false,
                        lineWidth: 0.7,
                        color: "#00639F",
                        data: [],
                    }],
                    exporting: {
                        filename: `ALARMES-LASA-AQM-EVOLUCAO-DIARIA`,
                        buttons: {
                            contextButton: {
                                menuItems: dashboard.menu
                            }
                        },chartOptions: {
                            chart: {
                                backgroundColor: '#ffffff',
                                events: {
                                    load: function () {
                                        this.renderer.image("/img/alarmes-logo.png", (this.chartWidth / 2) - 75, (this.chartHeight / 2) - 75, 150, 150).attr({ opacity: 0.15 }).add().toFront();
                                    }
                                }
                            }
                        }
                    }
                })
            },
            last: () => {
                dashboard.charts.last = Highcharts.chart('chart-last', {
                    title: { text: 'Média dos Últimos Dias', align: 'center', style: dashboard.style.title },
                    subtitle: { text: 'Bioma - Área ', align: 'center', style: dashboard.style.subtitle },
                    chart: {
                        type: 'column',
                        backgroundColor: null
                    },
                    xAxis: {
                        categories: ["7 dias", "15 dias", "30 dias", "60 dias"],
                        crosshair: true,
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Área queimada por dia (ha/dia)',
                            style: {
                                color: "#999999"
                            }
                        }
                    },
                    series: [
                        
                        {
                            name: 'Ano corrente',
                            color: "#E47834",
                            data: []
                        },
                        {
                            name: 'Histórica',
                            color: "#00639F",
                            data: []
                        }

                    ],
                    exporting: {
                        filename: `ALARMES-LASA-AQM-MEDIA-ULTIMOS-DIAS`,
                        buttons: {
                            contextButton: {
                                menuItems: dashboard.menu
                            }
                        },chartOptions: {
                            chart: {
                                backgroundColor: '#ffffff',
                                events: {
                                    load: function () {
                                        this.renderer.image("/img/alarmes-logo.png", (this.chartWidth / 2) - 75, (this.chartHeight / 2) - 75, 150, 150).attr({ opacity: 0.15 }).add().toFront();
                                    }
                                }
                            }
                        }
                    }
                })
            },
            yearly: () => {
                dashboard.charts.yearly = Highcharts.chart('chart-yearly', {
                    title: { text: 'Comparativo Anual', align: 'center', style: dashboard.style.title },
                    subtitle: { text: 'Bioma - Área ', align: 'center', style: dashboard.style.subtitle },
                    chart: {
                        type: 'column',
                        backgroundColor: null,
                    },
                    xAxis: {
                        categories: []
                    },
                    yAxis: [{
                        title: {
                            text: 'Área queimada (ha)',
                            style: {
                                color: "#999999"
                            }
                        }
                    }],
                    legend: {
                        shadow: false
                    },
                    tooltip: {
                        shared: true
                    },
                    plotOptions: {
                        column: {
                            grouping: false,
                            shadow: false,
                            borderWidth: 0
                        }
                    },
                    series: [{
                        name: 'Total',
                        color: 'rgba(248,161,63,1)',
                        data: [],
                        pointPadding: 0.3,
                        pointPlacement: 0.2
                    }, {
                        name: 'Última atualização',
                        color: 'rgba(186,60,61,.9)',
                        data: [],
                        pointPadding: 0.4,
                        pointPlacement: 0.2
                    }],
                    exporting: {
                        filename: `ALARMES-LASA-AQM-COMPARATIVO-ANUAL`,
                        buttons: {
                            contextButton: {
                                menuItems: dashboard.menu
                            }
                        },chartOptions: {
                            chart: {
                                backgroundColor: '#ffffff',
                                events: {
                                    load: function () {
                                        this.renderer.image("/img/alarmes-logo.png", (this.chartWidth / 2) - 75, (this.chartHeight / 2) - 75, 150, 150).attr({ opacity: 0.15 }).add().toFront();
                                    }
                                }
                            }
                        }
                    }
                })

            },
            monthly: () => {
                dashboard.charts.monthly = Highcharts.chart('chart-monthly', {
                    title: { text: 'Comparativo Mensal', align: 'center', style: dashboard.style.title },
                    subtitle: { text: 'Bioma - Área ', align: 'center', style: dashboard.style.subtitle },
                    chart: {
                        zooming: {
                            type: 'xy'
                        },
                        backgroundColor: null
                    },
                    xAxis: [{
                        categories: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                        crosshair: true
                    }],
                    yAxis: [{
                        title: {
                            text: 'Área queimada (ha)',
                            style: {
                                color: "#999999"
                            }
                        }
                    }],
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom'
                    },
                    series: [{
                        name: 'Média histórica',
                        type: 'column',
                        color: "#00639F",
                        data: []

                    }, {
                        name: 'Ano corrente',
                        type: 'spline',
                        color: "#E47834",
                        data: []
                    }],
                    exporting: {
                        filename: `ALARMES-LASA-AQM-COMPARATIVO-MENSAL`,
                        buttons: {
                            contextButton: {
                                menuItems: dashboard.menu
                            }
                        },chartOptions: {
                            chart: {
                                backgroundColor: '#ffffff',
                                events: {
                                    load: function () {
                                        this.renderer.image("/img/alarmes-logo.png", (this.chartWidth / 2) - 75, (this.chartHeight / 2) - 75, 150, 150).attr({ opacity: 0.15 }).add().toFront();
                                    }
                                }
                            }
                        }
                    }
                })
            },
            // categories: () => {
            //     dashboard.charts.biome = Highcharts.chart('chart-biome', {
            //         title: { text: 'Área queimada por categorias (%)', align: 'center', style: dashboard.style.title },
            //         subtitle: { text: 'Bioma - Área ', align: 'center', style: dashboard.style.subtitle },
            //         chart: {
            //             type: 'pie',
            //             plotShadow: false,
            //             backgroundColor: null,
            //             plotBorderWidth: null,
            //             plotBackgroundColor: null
            //         },
            //         tooltip: {
            //             pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            //         },
            //         accessibility: {
            //             point: {
            //                 valueSuffix: '%'
            //             }
            //         },
            //         plotOptions: dashboard.init.chart.options.plot(),
            //         series: [{
            //             name: 'Área queimada',
            //             data: []
            //         }],
            //         exporting: {
            //             filename: `ALARMES-LASA-AQM-POR-CATEGORIA`,
            //             buttons: {
            //                 contextButton: {
            //                     menuItems: dashboard.menu
            //                 }
            //             },chartOptions: {
            //                 chart: {
            //                     backgroundColor: '#ffffff',
            //                     events: {
            //                         load: function () {
            //                             this.renderer.image("/img/alarmes-logo.png", (this.chartWidth / 2) - 75, (this.chartHeight / 2) - 75, 150, 150).attr({ opacity: 0.15 }).add().toFront();
            //                         }
            //                     }
            //                 }
            //             }
            //         }
            //     })
            // },
            options: {
                gradient: (colors) => {
                    return {
                        linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
                        stops: [
                            [0, colors[0]],
                            [1, colors[1]]
                        ]
                    }
                },
                plot: () => {
                    return {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                format: `
                                    <span style="font-size: 1.2em"><b>{point.name}</b></span><br>
                                    <span style="opacity: 0.6">{point.percentage:.1f}%</span>
                                `,
                                connectorColor: "rgba(128,128,128,0.5)"
                            }
                        }
                    }
                }
            }
        },
        table: {
            raking: () => {
                $.getJSON(`${dashboard.workspace}/dashboard/ranking`, function (response) {
                    $('#table-ranking').bootstrapTable({
                        data: response,
                        filterControl: true,
                        // disableUnusedSelectOptions: true,
                        columns: [
                            {
                                field: "name",
                                title: "Nome",
                                sortable: true,
                                filterControl: 'input',
                                filterStrictSearch: false,
                            },
                            {
                                field: "uf",
                                title: "UF",
                                sortable: true,
                                filterControl: 'select',
                                filterStrictSearch: false
                            },
                            {
                                field: "category",
                                title: "Categoria",
                                sortable: true,
                                filterControl: 'select',
                                filterStrictSearch: false
                            },
                            {
                                field: "biome",
                                title: "Bioma",
                                sortable: true,
                                filterControl: 'select',
                                filterStrictSearch: false
                            },
                            {
                                field: "total",
                                title: "Total (ha)",
                                sortable: true,
                                filterControl: 'input',
                                filterStrictSearch: false
                            },
                            {
                                field: "percent",
                                title: "Percentual (%)",
                                sortable: true,
                                filterControl: 'input',
                                filterStrictSearch: false
                            }
                        ]

                    })

                    $('#table-ranking').on('post-header.bs.table', function () {
                        $('th[data-field="total"] input').prop('disabled', true);
                        $('th[data-field="percent"] input').prop('disabled', true);
                    })
                })

            }
        }
    },
    refresh: {
        all: (area_id) => {
            if (area_id == false) {
                area_id = $('#select-dash-areas').val()
            }

            $.getJSON(`${dashboard.workspace}/dashboard/logs/${area_id}`, function (response) {

                dashboard.logs = response
                dashboard.logs.area.subtitle = `${dashboard.logs.area.category} - ${dashboard.logs.area.name}`
                dashboard.logs.area.sufix = `${dashboard.logs.area.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "-").toUpperCase()}-${dashboard.today.toISOString().split('T')[0].replace(/-/g, "") }`
                
                console.log(dashboard.logs.area)
                dashboard.refresh.info()

                dashboard.refresh.chart.accum()
                dashboard.refresh.chart.last()
                dashboard.refresh.chart.movel()
                dashboard.refresh.chart.yearly()
                dashboard.refresh.chart.monthly()
                dashboard.refresh.table.monthly()
                // dashboard.refresh.chart.categories()
            }).fail(function () {
                alert(`Erro ao carregar informações da area [ID=${dashboard.id}]`)
            })
        },
        areas: () => {
            $.getJSON(`${dashboard.workspace}/dashboard/areas/${$("#select-dash-categories").val()}`, function (areas) {
                dashboard.refresh.all(areas[0].id)
                
                let elem = $('#select-dash-areas').empty()
                for (i in areas)
                    elem.append(`<option value="${areas[i].id}" biome_id="${areas[i].biome_id}" uf="${areas[i].uf}" >${areas[i].name}</option>`)
                })
        },  
        chart: {
            accum: () => {
                categories = []

                // Removing all series
                while (dashboard.charts.accum.series.length) {
                    dashboard.charts.accum.series[0].remove();
                }

                serie = null
                last = { year: -1 }
                accum = 0
                dashboard.logs.daily.forEach(log => {
                    if (last.year != log.year) {
                        if (serie != null)
                            dashboard.charts.accum.addSeries(serie, false)

                        serie = { name: log.year, data: [], color: dashboard.style.chart.accum(log.year), marker: false }
                        accum = 0
                    }

                    accum += log.value
                    serie.data.push([new Date(`2025-${log.month}-${log.day}`), accum])

                    if (log.year == 2024){
                        categories.push(`${log.day}/${log.month}`)
                    }

                    last = log
                })

                dashboard.charts.accum.addSeries(serie)
                dashboard.charts.accum.redraw()

                dashboard.charts.accum.update({ subtitle: { text: `${dashboard.logs.area.subtitle}` }, exporting: { filename: `ALARMES-LASA-AQM-ACUMULADO-${dashboard.logs.area.sufix}` }})
                dashboard.charts.accum.xAxis[0].update({ categories: categories })
            },
            last: () => {

                data = { "last": [], "avg": [] }
                for (index of Array(4).keys()) {
                    dashboard.logs.last[index] = parseFloat(dashboard.logs.last[index].value)
                    dashboard.logs.last_avg[index] = parseFloat(dashboard.logs.last_avg[index].value)
                }
                dashboard.charts.last.series[1].update({ data: dashboard.logs.last_avg })
                dashboard.charts.last.series[0].update({ data: dashboard.logs.last })

                dashboard.charts.last.update({ subtitle: { text: `${dashboard.logs.area.subtitle}` }, exporting: { filename: `ALARMES-LASA-AQM-MEDIA-ULTIMOS-DIAS-${dashboard.logs.area.sufix}`} })
            },
            movel: () => {
                categories = []
                data = { "daily": [], "movel": [] }

                cont = 1
                dashboard.logs.movel.forEach(log => {
                    if (log.month <= dashboard.today.getMonth() + 1 || dashboard.today.getDate() <= log.day) {
                        categories.push(`${log.day}/${log.month}`)
                        data["daily"].push(log.value)

                        if (cont > 6 ){
                            data["movel"].push(parseInt(log.avg))
                        }
                        else {
                            data["movel"].push(null)
                            cont ++
                        }
                    }
                })

                dashboard.charts.movel.xAxis[0].update({ categories: categories })
                dashboard.charts.movel.series[0].update({ data: data['daily'] })
                dashboard.charts.movel.series[1].update({ data: data['movel'] })
                dashboard.charts.movel.redraw()

                dashboard.charts.movel.update({ subtitle: { text: `${dashboard.logs.area.subtitle}` }, exporting: { filename: `ALARMES-LASA-AQM-EVOLUCAO-DIARIA-${dashboard.logs.area.sufix}`} })

            },
            yearly: () => {

                categories = []
                data = { "current": [], "historic": [] }
                dashboard.logs.yearly.forEach(log => {
                    categories.push(log.year)
                    data["current"].push(log.current)
                    data["historic"].push(parseInt(log.historic))
                })

                dashboard.charts.yearly.xAxis[0].update({ categories: categories })
                dashboard.charts.yearly.series[0].update({ data: data['current'] })
                dashboard.charts.yearly.series[1].update({ data: data['historic'] })

                dashboard.charts.yearly.update({ subtitle: { text: `${dashboard.logs.area.subtitle}` }, exporting: { filename: `ALARMES-LASA-AQM-COMPARATIVO-ANUAL-${dashboard.logs.area.sufix}`} })
            },
            monthly: () => {
                categories = []
                data = { "current": [], "historic": [] }
                dashboard.logs.monthly.forEach(log => {
                    data["historic"].push(parseInt(log.historic))
                    data["current"].push(log.current)
                })

                dashboard.charts.monthly.series[0].update({ data: data['historic'] })
                dashboard.charts.monthly.series[1].update({ data: data['current'] })
                dashboard.charts.monthly.redraw()

                dashboard.charts.monthly.update({ subtitle: { text: `${dashboard.logs.area.subtitle}` }, exporting: { filename: `ALARMES-LASA-AQM-COMPARATIVO-MENSAL-${dashboard.logs.area.sufix}`} })
            },
            // categories: () => {
            //     // Reseting tab state

            //     console.log(dashboard.logs.categories, dashboard.logs.categories == [])
            //     $("#tab-if-category").removeClass("active")
            //     $("#tab-if-not-category").addClass("active")

            //     $("#tab-7").removeClass("active show")
            //     $("#tab-6").addClass("active show")

            //     if (dashboard.logs.categories.length == 0) {
            //         $("#nav-tab-if-category").addClass("d-none")
            //     }
            //     else {
            //         $("#nav-tab-if-category").removeClass("d-none")

            //         colors = dashboard.util.colors("categories")

            //         sum = 0
            //         data = []
                    
            //         dashboard.logs.categories.forEach((category, i) => {
            //             if (category.name != 'OU') {
            //                 sum += category.sum
            //                 data.push({ name: category.name, y: category.sum, color: dashboard.init.chart.options.gradient(colors[i]) })
            //             }
            //             else {
            //                 data.push({ name: 'Não Categorizado', y: category.sum - sum, color: dashboard.init.chart.options.gradient(colors[i]) })
            //             }
            //         })
            //         dashboard.charts.biome.series[0].update({ data: data })
            //         dashboard.charts.biome.redraw()

            //         dashboard.charts.biome.update({ subtitle: { text: `${dashboard.logs.area.subtitle}` }, exporting: { filename: `ALARMES-LASA-AQM-POR-CATEGORIA-${dashboard.logs.area.sufix}`} })

            //     }
            // }
        },
        info: () => {
            $("#info-name").html(dashboard.logs.area.name)
            $("#info-size").html(dashboard.logs.area.size_ha + " ha")
            $("#info-period").html("01-01-" +dashboard.today.getFullYear() + " a " + dashboard.logs.metrics.max_date)

            $("#info-burned").html(dashboard.logs.metrics.burned + " ha")

            $("#info-percent").html(dashboard.logs.metrics.percent + "%")
            $("#percent").css('width', `${dashboard.logs.metrics.percent}%`);
        },
        table: {
            monthly: () => {
                html = ""
                dashboard.logs.table.forEach(log => {
                    tds = ""
                    sum = 0
                    for (const [key, value] of Object.entries(log)) {
                        tds += `<td>${value || '-'}</td>`
                        if (key != 'year')
                            sum += parseInt(value) || 0
                    }
                    tds += `<td>${sum}</td>`
                    html += `<tr >${tds}</tr>`
                })
                $("#table-monthly-tbody").html("")
                $("#table-monthly").bootstrapTable('destroy')
                $("#table-monthly-tbody").html(html)
                $("#table-monthly").bootstrapTable()
            }
        }
    },
    style: {
        chart: {
            accum: (year) => {
                if (year == dashboard.today.getFullYear())
                    return "#E47834"
                else
                    return "#BBBBBB"
            }
        }
    },
    util: {
        colors: (id) => {

            switch (id) {
                case "categories":
                    return [
                        ["#FF0000", "#AB0202"],
                        ["#A148DB", "#833AB4"],
                        ["#FC8E45", "#D45B0B"],
                        ["#1643BE", "#1C1CAD"],
                        ["#22C1C3", "#159C9E"],
                        ["#14BD11", "#0A8508"],
                        ["#090979", "#00D4FF"],
                        ["#FF0000", "#AB0202"],
                        ["#A148DB", "#833AB4"],
                    ]
                default:
                    break
            }

            return {

            }

        }
    }
}

dashboard.init.all()
